/*
 * Generated type guards for "types.ts".
 * WARNING: Do not manually change this file.
 */
import {SuccessResponse, FailureResponse, Response} from './types';

export function isSuccessResponse(obj: unknown): obj is SuccessResponse {
  const typedObj = obj as SuccessResponse;
  return (
    ((typedObj !== null && typeof typedObj === 'object') || typeof typedObj === 'function') &&
    typedObj['success'] === true
  );
}

export function isFailureResponse(obj: unknown): obj is FailureResponse {
  const typedObj = obj as FailureResponse;
  return (
    ((typedObj !== null && typeof typedObj === 'object') || typeof typedObj === 'function') &&
    typedObj['success'] === false &&
    typeof typedObj['errorMessage'] === 'string'
  );
}

export function isResponse(obj: unknown): obj is Response {
  const typedObj = obj as Response;
  return (isSuccessResponse(typedObj) as boolean) || (isFailureResponse(typedObj) as boolean);
}
